<template>
  <div>
    <el-table
        :data="links.data"
        @sort-change="sort"
        class="w100"
        stripe
    >
    <el-table-column label="Asset Label" prop="asset_label">
        <template slot-scope="props">
          {{ props.row.asset_label }}
        </template>
      </el-table-column>
      <el-table-column label="Channel ID" prop="channel_id">
        <template slot-scope="props">
            {{ props.row.channel_id }}
        </template>
      </el-table-column>
      <el-table-column label="Report type" prop="report_type">
        <template slot-scope="props">
          {{ getReportTypeName(props.row.report_type) }}
        </template>
      </el-table-column>
      <el-table-column label="Create date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip content="Delete" placement="top">
            <el-button
                type="danger"
                circle
                size="small"
                icon="el-icon-close"
                @click="deleteLink(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        class="float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="links.current_page"
        :page-sizes="[5, 10, 25, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="links.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    user: {
      type: Object,
    }
  },
  computed: {
    ...mapState('mcnChannels', [
      'links',
      'page',
      'page_size',
      'order_column',
      'order_type',
      'mcn_managers'
    ])
  },

  methods: {
    ...mapActions('mcnChannels', [
      'read',
      'delete',
      'readMcnManagers'
    ]),
    ...mapMutations('mcnChannels', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialog'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    deleteLink(id) {
      this.$confirm(
          'You will permanently delete this channel. Continue?',
          'Warning',
          {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
      )
          .then(() => {
            this.delete(id)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: 'Delete cancelled'
            })
          })
    },
    getManagerName(managerId) {
      const manager = this.mcn_managers.find(manager => manager.id === managerId)
      return manager ? manager.username : 'Unknown'
    },
    getReportTypeName(reportType) {
      const reportTypes = {
        1: 'Label',
        2: 'MCN'
      };
      return reportTypes[reportType] || '';
    }
  },

  created() {
    let userId = null;

    // Check if user exists and assign the user ID if available
    if (this.user && this.user.id) {
      userId = this.user.id;
    }
    this.read(userId)
    this.readMcnManagers()
  }
}
</script>